/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfilePicture/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ProfilePicture({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/Patient/Content/PatientSearch/Results/Content/Option/ProfilePicture",
  presignedUrl
  
}) {
let personValueData = fromData.useDataFormat({ viewPath,
context: 'person',
format: fromFormat.initials,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="person"
 format="/Data/format.js initials"
 initials={personValueData}
 size="medium"
 width={32}
 height={32}
 marginRight={dtSpaceXs}
 borderTopLeftRadius="50%"
 borderTopRightRadius="50%"
 borderBottomLeftRadius="50%"
 borderBottomRightRadius="50%"
 backgroundColor={dtColorsNeutral200}
/>
{children}
</React.Fragment>)
}